import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/all.css";
import base_url from "@/constant/url.js";

import translate from "i18n-jsautotranslate";
translate.selectLanguageTag.show = false; //是否显示切换栏
translate.listener.start(); //监控页面动态渲染的文本进行自动翻译
translate.service.use("client.edge"); //翻译通道
translate.whole.enableAll(); //整体翻译
translate.ignore.text.push("中文");
translate.ignore.text.push("English");

import axios from "axios";
axios.interceptors.response.use((res) => {
  translate.execute();
  return res;
});

Vue.config.productionTip = false;
Vue.prototype.base_url = base_url;

Vue.use(ElementUI);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
